import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import axios from "axios";
import './Course.css'
import { API } from '../backend';
import { ThreeDots } from 'react-loading-icons'
import Loading from '../loading/loading';




const Course = () => {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // Get data from navigate state
  const contenteId = location.state?.contenteId;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = Cookies.get("token"); // Get the token from cookies

        const headers = {
          "Content-Type": "application/json",
        };

        if (token) {
          // If token exists, add Authorization header
          headers["Authorization"] = `Token ${token}`;
        }
        const response = await axios.get(`${API}api/v1/course/${contenteId}/`,
          { headers }
        );
        
        setCourse(response.data);
      } catch (error) {
        console.error("Error fetching course:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourse();
  }, []);


  if (loading) {
    return (
        <>
        <div className="loading-container-course">
            <Loading/>
        </div>
        <div className="loading-container-course-mobile">
            <Loading/>
        </div>
        </>
    )
  }

  const handleCourseClick = (sectionId) => {
    navigate("/video", { state: { contenteId, sectionId} });
  };

  console.log(course.sections)
  return (
    <>
    <div className='course-container'>
    <div className='course-margin-top'></div>
    <div className='course'>
        <p className='courses-title'>{course.title}</p>
        <p className='courses-text'>{course.description}</p>
    </div>
    <div className='space-between-list'></div>
    <div className='course-list'>
        <p className='course-list-title'>لیست دروس</p>
        {course.sections.map((section, index) => (
          <div key={index} className="course-margin">
            <div className='course-container1'>
                <div className='left-course'>
                  <div className='course-image-div'>
                    <img
                    className="course-image"
                    src={section.image || require('../images/course-image.png')}
                    alt={section.title}
                    />
                  </div>
                </div>
                <div className='right-course'>
                    <div className='course-spacer'>
                        <p className='course-counter'>
                        درس 0{section.order}/0{course.sections.length}
                        <svg className='courses-svg' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.33333 28.3333H15C17.7614 28.3333 20 30.5719 20 33.3333V16.6667C20 11.9526 20 9.5956 18.5355 8.13113C17.0711 6.66666 14.714 6.66666 10 6.66666H8.33333C6.76198 6.66666 5.97631 6.66666 5.48816 7.15482C5 7.64297 5 8.42865 5 9.99999V25C5 26.5713 5 27.357 5.48816 27.8452C5.97631 28.3333 6.76198 28.3333 8.33333 28.3333Z" fill="#E53B1F" />
                            <path d="M31.6665 28.3333H26.6665C23.9051 28.3333 21.6665 30.5719 21.6665 33.3333V16.6667C21.6665 11.9526 21.6665 9.5956 23.131 8.13113C24.5954 6.66666 26.9525 6.66666 31.6665 6.66666C33.2379 6.66666 34.0235 6.66666 34.5117 7.15482C34.9998 7.64297 34.9998 8.42865 34.9998 9.99999V25C34.9998 26.5713 34.9998 27.357 34.5117 27.8452C34.0235 28.3333 33.2379 28.3333 31.6665 28.3333Z" fill="#3CCFF1" fill-opacity="0.5" />
                            <path d="M8.3335 6.91666C8.3335 6.77859 8.44542 6.66666 8.5835 6.66666H13.0835C13.2216 6.66666 13.3335 6.77859 13.3335 6.91666V13.9941C13.3335 14.3653 12.8847 14.5512 12.6222 14.2887L11.1281 12.7946C10.9654 12.6319 10.7016 12.6319 10.5389 12.7946L9.04479 14.2887C8.78231 14.5512 8.3335 14.3653 8.3335 13.9941V6.91666Z" fill="#3CCFF1" fill-opacity="0.5" />
                        </svg>
                        </p>
                        <div className='course-title-button'>
                            <button className={`course-btn ${section.status ? 'green-btn' : ''}`}>
                              {section.status ? `${section.gift_token} توکن دریافت شده` : `${section.gift_token || 0} توکن ایوا کسب کن`}
                            </button>
                            <p className='course-section-title'>{section.title}</p>
                        </div>
                        <p className='course_description'>{section.description}</p>
                        <button className='collect-btn' onClick={() => handleCourseClick(section.id)}>دریافت کن</button>
                    </div>
                </div>
            </div>
        </div>
        ))}
    </div>
    <div className='space-between-footer'></div>
    </div>

    <div className='course-container-mobile'>
      <div className='course-margin-top-mobile'></div>
      <div className='course'>
        <p className='courses-title-mobile'>{course.title}</p>
        <p className='courses-text-mobile'>{course.description}</p>
        <div className='space-between-list-mobile'></div>
        <p className='course-list-title-mobile'>لیست دروس</p>
      </div>
      
      {course.sections.map((section, index) => (
      <div key={index} className="course-margin-mobile">
        <div className='course-container1-mobile'>
            <div className='course-image-mobile-div'>
              <img className="course-image-mobile" src={section.image || require('../images/course-image.png')} alt={section.title}/>
            </div>
            <div className='course-margin-between-mobile'></div>
            <div className='course-spacer-mobile'>
              <p className='course-counter-mobile'>
                درس 0{section.order}/0{course.sections.length}
                <svg className='courses-svg-mobile' viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.33333 28.3333H15C17.7614 28.3333 20 30.5719 20 33.3333V16.6667C20 11.9526 20 9.5956 18.5355 8.13113C17.0711 6.66666 14.714 6.66666 10 6.66666H8.33333C6.76198 6.66666 5.97631 6.66666 5.48816 7.15482C5 7.64297 5 8.42865 5 9.99999V25C5 26.5713 5 27.357 5.48816 27.8452C5.97631 28.3333 6.76198 28.3333 8.33333 28.3333Z" fill="#E53B1F" />
                  <path d="M31.6665 28.3333H26.6665C23.9051 28.3333 21.6665 30.5719 21.6665 33.3333V16.6667C21.6665 11.9526 21.6665 9.5956 23.131 8.13113C24.5954 6.66666 26.9525 6.66666 31.6665 6.66666C33.2379 6.66666 34.0235 6.66666 34.5117 7.15482C34.9998 7.64297 34.9998 8.42865 34.9998 9.99999V25C34.9998 26.5713 34.9998 27.357 34.5117 27.8452C34.0235 28.3333 33.2379 28.3333 31.6665 28.3333Z" fill="#3CCFF1" fill-opacity="0.5" />
                  <path d="M8.3335 6.91666C8.3335 6.77859 8.44542 6.66666 8.5835 6.66666H13.0835C13.2216 6.66666 13.3335 6.77859 13.3335 6.91666V13.9941C13.3335 14.3653 12.8847 14.5512 12.6222 14.2887L11.1281 12.7946C10.9654 12.6319 10.7016 12.6319 10.5389 12.7946L9.04479 14.2887C8.78231 14.5512 8.3335 14.3653 8.3335 13.9941V6.91666Z" fill="#3CCFF1" fill-opacity="0.5" />
                </svg>
              </p>
              <div className='course-title-button'>
                <button className={`course-btn-mobile ${section.status ? 'green-btn' : ''}`}>
                  {section.status ? `${section.gift_token} توکن دریافت شده` : `${section.gift_token || 0} توکن ایوا کسب کن`}
                </button>
                <p className='course-section-title-mobile'>{section.title}</p>
              </div>
                <p className='course_description-mobile'>{section.description}</p>
                <button className='collect-btn-mobile' onClick={() => handleCourseClick(section.id)}>دریافت کن</button>
            </div>
        </div>
      </div>
      ))}   

    </div>
    
    </>
  )
}

export default Course